import React, { Fragment, useState, useMemo } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Button, Card, CardHeader, CardBody, Container, Row, Col, Badge } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { Plus, Edit, Eye } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useGetStoresQuery } from '../../../../store/services/inventoryApi';

const StoreManagement = () => {
  const navigate = useNavigate();
  const { data: stores, isLoading, error } = useGetStoresQuery();
  const [filterText, setFilterText] = useState('');

  const filteredItems = useMemo(() => {
    if (!stores) return [];
    const list = Array.isArray(stores) ? stores : (stores.data || []);
    return list.filter(item =>
      item.storeName && item.storeName.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [stores, filterText]);

  const columns = [
    {
      name: 'Store Name',
      selector: row => row.storeName,
      sortable: true,
    },
    {
      name: 'Store Number',
      selector: row => row.storeNumber || 'N/A',
      sortable: true,
    },
    {
      name: 'Store Manager',
      selector: row => row.storeManager || 'N/A',
      sortable: true,
    },
    {
      name: 'Contact Phone',
      selector: row => row.phone || 'N/A',
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      cell: row => (
        <Badge color={row.status === 'active' ? 'success' : 'danger'}>
          {row.status === 'active' ? 'Active' : 'Inactive'}
        </Badge>
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex">
          <Button color="transparent" size="xs" className="p-0 me-2" onClick={() => navigate(`/inventory/stores/${row._id}`)}>
            <Eye size={16} className="text-primary" />
          </Button>
          <Button color="transparent" size="xs" className="p-0 me-2" onClick={() => navigate(`/inventory/stores/edit/${row._id}`)}>
            <Edit size={16} className="text-primary" />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumbs parent="Inventory" title="Store Management" mainTitle="Stores" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5>Store List</h5>
                <div className="d-flex gap-2">
                  <input
                     type="text"
                     className="form-control"
                     placeholder="Search Store..."
                     value={filterText}
                     onChange={e => setFilterText(e.target.value)}
                     style={{ width: '250px' }}
                   />
                  <Button color="primary" size="sm" onClick={() => navigate('/inventory/stores/create')}>
                    <Plus size={16} className="me-1" /> Add Store
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  progressPending={isLoading}
                  highlightOnHover
                  striped
                  responsive
                  noDataComponent={<div className="p-4 text-center text-muted">No stores found</div>}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default StoreManagement;
